const getDoctorsApiUrl = () => process.env.REACT_APP_URL_PROD_MEDAM;
// process.env.REACT_APP_PROD_MEDAM || process.env.REACT_APP_URL_PROD_MEDAM;

const normalizeDoctor = (doctor = {}) => {
  const specialty =
    typeof doctor.especialidad === "object" && doctor.especialidad !== null
      ? doctor.especialidad.label || doctor.especialidad.value || ""
      : doctor.especialidad || "";

  return {
    ...doctor,
    especialidad: specialty,
  };
};

export const getDoctorsFromApi = async ({ query = "" } = {}) => {
  const baseUrl = (getDoctorsApiUrl() || "").replace(/\/+$/, "");

  if (!baseUrl) {
    return [];
  }

  try {
    const response = await fetch(
      `${baseUrl}/employees/listOfEmployees/doctor`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const payload = await response.json();
    if (!Array.isArray(payload?.data)) {
      return [];
    }

    return payload.data.map((doctor, index) => normalizeDoctor(doctor, index));
  } catch (error) {
    console.error("No se pudieron cargar los doctores:", error);
    return [];
  }
};
